import React from 'react';
import { Popover, Box } from '@mui/material';
import { AppointmentTypeChanges } from '../../types/appointmentChanges';
import { AppointmentType, ExpandableFieldItem } from '@features/appointment-types';
import { UserTemplateItem } from '../../../../types/types';
import { UpdatePreviewContent } from './UpdatePreviewContent';

interface UpdatePreviewPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  appointmentTypeName: string;
  changes?: AppointmentTypeChanges;
  selectedAppointmentType?: AppointmentType;
  currentDuration?: number;
  currentTelehealth?: boolean;
  currentForms?: ExpandableFieldItem[];
  currentReminders?: ExpandableFieldItem[];
  currentTemplate?: UserTemplateItem | null;
  onClose: () => void;
}

export const UpdatePreviewPopover: React.FC<UpdatePreviewPopoverProps> = ({
  open,
  anchorEl,
  appointmentTypeName,
  changes,
  selectedAppointmentType,
  currentDuration,
  currentTelehealth,
  currentForms = [],
  currentReminders = [],
  currentTemplate,
  onClose,
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      sx={{
        pointerEvents: 'none',
        '& .MuiPopover-paper': {
          maxWidth: '80vw',
          minWidth: 300,
          width: 'fit-content', // Adjust width to content
        },
      }}
      marginThreshold={16} // Minimum distance from viewport edge
      disableRestoreFocus // Prevent focus issues
    >
      <Box sx={{ p: 2 }}>
        <UpdatePreviewContent
          appointmentTypeName={appointmentTypeName}
          changes={changes}
          selectedAppointmentType={selectedAppointmentType}
          currentDuration={currentDuration}
          currentTelehealth={currentTelehealth}
          currentForms={currentForms}
          currentReminders={currentReminders}
          currentTemplate={currentTemplate}
        />
      </Box>
    </Popover>
  );
};

export default UpdatePreviewPopover;
